export default __webpack_public_path__ + "static/media/web-application-banner.e4fda2c3.svg";